import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c(VCard,[_c(VCardTitle,{staticClass:"titulopagina"},[_vm._v("REPORTE ESTADO EQUIPOS")])],1),_c('data-table-filtro',{staticClass:"mt-5",on:{"editar":function($event){return _vm.editar($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }